export type EmailBlast = {
	subject: string;
	body: string;
};

export const EmptyEmailBlast: EmailBlast = {
	subject: '',
	body: ''
};
